module.exports = __webpack_public_path__ + "img/Musa-Afandiyev.bf2f8eb9.jpeg";